import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
	deleteCreditNote,
	fetchCreditNoteDetails,
} from '../../../../../services/sales_credit_note';
import { toast } from 'react-toastify';
import pdfMake from 'pdfmake/build/pdfmake';
import { generateCreditNotePdf } from '../components/generateCreditNotePdf';
import UseCreditNote from './useCreditNote';

const UseCreditNoteDetails = () => {
	const [creditNoteDetails, setCreditNoteDetails] = useState([]);
	const [isDeleteCNModalOpen, setIsDeleteCNModalOpen] = useState(false);
	const [isApplyInvoiceModalOpen, setIsApplyInvoiceModalOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const { handlePrintAndDownloadPdf } = UseCreditNote();
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');

	async function getCreditNoteDetails() {
		try {
			setLoading(true);
			var { credit_note } = await fetchCreditNoteDetails({ ids: [id] });
			setCreditNoteDetails(credit_note);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	}
	async function handleDeleteCreditNote() {
		try {
			var body = JSON.stringify({
				ids: [id],
			});
			await deleteCreditNote(body);
			toast.success('Credit Note deleted successfully');
			navigate(`/user/${suburl}/sales/credit-note`);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	}

	async function generateSalesCreditNotePdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	useEffect(() => {
		if (id) {
			getCreditNoteDetails();
		}
	}, [id]);

	return {
		creditNoteDetails,
		isDeleteCNModalOpen,
		setIsDeleteCNModalOpen,
		setIsApplyInvoiceModalOpen,
		isApplyInvoiceModalOpen,
		loading,
		navigate,
		id,
		suburl,
		generateSalesCreditNotePdf,
		handleDeleteCreditNote,
		getCreditNoteDetails,
	};
};
export default UseCreditNoteDetails;
